
import React from "react";

function ViewBookingEvent({ user, closeModal }) {
    if (!user) return null;
    const BASE_URL = process.env.REACT_APP_URL;
    function formatDate(date) {
        if (!date) return "N/A";

        const formattedDate = new Date(date);

        if (isNaN(formattedDate.getTime())) {
            return "N/A";
        }

        return formattedDate.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    }
    function formatTime(time) {
        if (!time) return "N/A";
        const [hours, minutes] = time.split(":");
        const date = new Date();
        date.setHours(Number(hours), Number(minutes));
        return date.toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    }
    const imageUrl = user?.eventId?.eventBanner
        ? `${BASE_URL}/${user.eventId.eventBanner.replace(/^\/+/, "")}`
        : null;
    return (
        <div
            className="modal fade viewbox edit-box show d-block"
            id="eventModal"
            tabIndex={-1}
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            Event Booking Details
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={closeModal}
                            aria-label="Close"
                        />
                    </div>
                    <div className="modal-body px-5">
                        <div className="d-box mt-3 pt-1">
                            <h3
                                className="service-heading"
                                style={{ marginBottom: "15px" }}
                            >
                                Booking Information
                            </h3>
                            <ul className="d-flex list-unstyled flex-wrap justify-content-between">
                                <li className="w-50 mb-3">
                                    <strong>Booking ID: </strong>
                                    {user?.bookingId || "N/A"}
                                </li>
                                <li className="w-50 mb-3">
                                    <strong>Ticket: </strong>
                                    {user?.ticketName || "N/A"}
                                </li>
                                <li className="w-50 mb-3">
                                    <strong>Quantity: </strong>
                                    {user?.quantity ?? "N/A"}
                                </li>
                                <li className="w-50 mb-3">
                                    <strong>Ticket Price: </strong>
                                    ₹{user?.price ?? "N/A"}
                                </li>
                                <li className="w-50 mb-3">
                                    <strong>Total Amount: </strong>
                                    ₹{user?.totalAmount ?? "N/A"}
                                </li>
                                <li className="w-50 mb-3">
                                    <strong>Payment Status: </strong>
                                    <span
                                        className={
                                            user?.paymentStatus === "Success"
                                                ? "badge bg-success"
                                                : "badge bg-warning text-dark"
                                        }
                                    >
                                        {user?.paymentStatus || "N/A"}
                                    </span>
                                </li>
                                <li className="w-50 mb-3">
                                    <strong>Booking Status: </strong>
                                    <span
                                        className={
                                            user?.bookingStatus === "Confirmed"
                                                ? "badge bg-success"
                                                : "badge bg-secondary"
                                        }
                                    >
                                        {user?.bookingStatus || "N/A"}
                                    </span>
                                </li>
                                <li className="w-50 mb-3">
                                    <strong>Check-In Status: </strong>
                                    <span
                                        className={
                                            user?.checkInStatus === "Checked-In"
                                                ? "badge bg-success"
                                                : "badge bg-secondary"
                                        }
                                    >
                                        {user?.checkInStatus || "N/A"}
                                    </span>
                                </li>

                                {/* QR Code */}
                                <li className="w-100 mb-3">
                                    <strong>QR Code: </strong>
                                    {user?.qrCode || "N/A"}
                                </li>
                            </ul>
                        </div>

                        {/* =========================
                            USER INFORMATION
                        ========================== */}
                        <div className="d-box mt-4 pt-1">

                            <h3
                                className="service-heading"
                                style={{ marginBottom: "15px" }}
                            >
                                Customer Information
                            </h3>

                            <ul className="d-flex list-unstyled flex-wrap justify-content-between">

                                {/* Name */}
                                <li className="w-50 mb-3">
                                    <strong>Name: </strong>

                                    {user?.userId?.firstName || ""}
                                    {" "}
                                    {user?.userId?.lastName || ""}
                                </li>

                                {/* Mobile */}
                                <li className="w-50 mb-3">
                                    <strong>Mobile: </strong>
                                    {user?.userId?.mobileNo || "N/A"}
                                </li>

                                {/* Email */}
                                <li className="w-50 mb-3">
                                    <strong>Email: </strong>
                                    {user?.userId?.email || "N/A"}
                                </li>
                            </ul>
                        </div>

                        {/* =========================
                            EVENT INFORMATION
                        ========================== */}
                        <div className="d-box mt-4 pt-1">

                            <h3
                                className="service-heading"
                                style={{ marginBottom: "15px" }}
                            >
                                Event Information
                            </h3>

                            <ul className="d-flex list-unstyled flex-wrap justify-content-between">

                                {/* Event Name */}
                                <li className="w-50 mb-3">
                                    <strong>Event Name: </strong>
                                    {user?.eventId?.eventName || "N/A"}
                                </li>

                                {/* Venue */}
                                <li className="w-50 mb-3">
                                    <strong>Venue: </strong>
                                    {user?.eventId?.venue || "N/A"}
                                </li>

                                {/* Event Date */}
                                <li className="w-50 mb-3">
                                    <strong>Event Date: </strong>
                                    {formatDate(user?.eventId?.eventDate)}
                                </li>

                                {/* Start Time */}
                                <li className="w-50 mb-3">
                                    <strong>Start Time: </strong>
                                    {formatTime(user?.eventId?.startTime)}
                                </li>

                                {/* End Time */}
                                <li className="w-50 mb-3">
                                    <strong>End Time: </strong>
                                    {formatTime(user?.eventId?.endTime)}
                                </li>

                                {/* Total Capacity */}
                                <li className="w-50 mb-3">
                                    <strong>Total Capacity: </strong>
                                    {user?.eventId?.totalCapacity ?? "N/A"}
                                </li>

                                {/* Description */}
                                <li className="w-100 mb-3">
                                    <strong>Description: </strong>

                                    <div
                                        style={{
                                            whiteSpace: "pre-line",
                                            marginTop: "5px",
                                        }}
                                    >
                                        {user?.eventId?.eventDescription || "N/A"}
                                    </div>
                                </li>
                            </ul>
                        </div>

                        {/* =========================
                            LOCATION
                        ========================== */}
                        <div className="d-box mt-4 pt-1">

                            <h3
                                className="service-heading"
                                style={{ marginBottom: "15px" }}
                            >
                                Location
                            </h3>

                            <ul className="d-flex list-unstyled flex-wrap justify-content-between">

                                {/* Address */}
                                <li className="w-100 mb-3">
                                    <strong>Address: </strong>
                                    {user?.eventId?.address || "N/A"}
                                </li>

                                {/* City */}
                                <li className="w-50 mb-3">
                                    <strong>City: </strong>
                                    {user?.eventId?.city || "N/A"}
                                </li>
                            </ul>
                        </div>

                        {/* =========================
                            CHECK-IN INFORMATION
                        ========================== */}
                        {user?.checkInStatus === "Checked-In" && (
                            <div className="d-box mt-4 pt-1">

                                <h3
                                    className="service-heading"
                                    style={{ marginBottom: "15px" }}
                                >
                                    Check-In Information
                                </h3>

                                <ul className="d-flex list-unstyled flex-wrap justify-content-between">

                                    {/* Checked In At */}
                                    <li className="w-50 mb-3">
                                        <strong>Checked-In At: </strong>
                                        {formatDate(user?.checkedInAt)}

                                        {user?.checkedInAt && (
                                            <div
                                                style={{
                                                    fontSize: "12px",
                                                    color: "#666",
                                                }}
                                            >
                                                {new Date(
                                                    user.checkedInAt
                                                ).toLocaleTimeString("en-IN", {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: true,
                                                })}
                                            </div>
                                        )}
                                    </li>

                                    {/* Checked By */}
                                    <li className="w-50 mb-3">
                                        <strong>Checked-In By: </strong>

                                        {user?.checkedInBy ? (
                                            <>
                                                <div>
                                                    Mobile:{" "}
                                                    {user.checkedInBy.mobileNo ||
                                                        "N/A"}
                                                </div>

                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "#666",
                                                    }}
                                                >
                                                    {user.checkedInBy.email ||
                                                        "N/A"}
                                                </div>
                                            </>
                                        ) : (
                                            "N/A"
                                        )}
                                    </li>
                                </ul>
                            </div>
                        )}

                        {/* =========================
                            EVENT IMAGE
                        ========================== */}
                        <div className="d-box mt-4 pt-1">

                            <h3
                                className="service-heading"
                                style={{ marginBottom: "15px" }}
                            >
                                Event Image
                            </h3>

                            {imageUrl ? (
                                <img
                                    src={imageUrl}
                                    alt={
                                        user?.eventId?.eventName || "Event"
                                    }
                                    style={{
                                        width: "150px",
                                        height: "150px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    onError={(e) => {
                                        e.target.style.display = "none";
                                    }}
                                />
                            ) : (
                                <span>N/A</span>
                            )}
                        </div>

                        {/* =========================
                            CREATED DATE
                        ========================== */}
                        <div className="d-box mt-4 pt-1">

                            <ul className="d-flex list-unstyled">
                                <li>
                                    <strong>Booking Created: </strong>
                                    {formatDate(user?.createdAt)}
                                </li>
                            </ul>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewBookingEvent;

